import { z } from 'zod';
import { ESTADOS } from '../dominio.js';
/**
 * Reportes. Se apoyan en las vistas de negocio de la base, que ya resuelven los
 * cruces: trazabilidad, proveedores homologados, bandeja y reevaluaciones.
 */
export const REPORTES = [
    'trazabilidad',
    'proveedores-aprobados',
    'evaluaciones-vencidas',
    'pendientes',
];
export const ETIQUETA_REPORTE = {
    trazabilidad: 'Trazabilidad de órdenes',
    'proveedores-aprobados': 'Proveedores aprobados (LOG-FT-05)',
    'evaluaciones-vencidas': 'Reevaluaciones vencidas',
    pendientes: 'Documentos pendientes de decisión',
};
export const DESCRIPCION_REPORTE = {
    trazabilidad: 'Cada orden con su requerimiento, sus pagos y el saldo por pagar.',
    'proveedores-aprobados': 'Proveedores homologados según su ficha de selección aprobada.',
    'evaluaciones-vencidas': 'Proveedores cuya reevaluación ya venció, según la regla del LOG-FT-04.',
    pendientes: 'Documentos esperando aprobación, con los días que llevan detenidos.',
};
export const filtroReporte = z.object({
    desde: z.iso.date().optional(),
    hasta: z.iso.date().optional(),
    estado: z.enum(ESTADOS).optional(),
    empresaId: z.coerce.number().int().positive().optional(),
});
/** Indicadores del tablero. */
export const resumen = z.object({
    documentosPorEstado: z.array(z.object({
        estado: z.enum(ESTADOS),
        cantidad: z.number().int(),
    })),
    ordenesPorEmpresa: z.array(z.object({
        empresa: z.string(),
        cantidad: z.number().int(),
        totalPen: z.number(),
    })),
    /** Cuánto tarda un documento en decidirse, desde su emisión. */
    diasPromedioAprobacion: z.number().nullable(),
    documentosDetenidos: z.number().int(),
    saldoPorPagar: z.number(),
    proveedoresAprobados: z.number().int(),
    reevaluacionesVencidas: z.number().int(),
});
/** Las filas de cada reporte son de forma distinta; se tipan sueltas. */
export const filaReporte = z.looseObject({});
//# sourceMappingURL=reporte.js.map